import { Link } from "react-router-dom";
import { useEffect, useState } from "react";

function MoviesPage() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    fetch("https://movie-backend-1wmv.onrender.com/api/articles?category=movies")
      .then(res => res.json())
      .then(data => setItems(data))
      .catch(() => setItems([]));
  }, []);

  // simple split logic
  const articles = items.filter(i => /article/i.test(i.type));
  const reviews = items.filter(i => /review/i.test(i.title));
  const boxoffice = items.filter(i => /box|box office/i.test(i.title));
 const stripHtml = (html) => {
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent || div.innerText || "";
  };
  return (
    <div className="container mt-5">
      <h1 className="text-center mb-4">Movies</h1>

      {/* 3-column layout: left tall column and right two stacked */}
      <div className="d-flex justify-content-center">
        <div className="d-flex w-100" style={{ maxWidth: 1200 }}>
          {/* Left column (tall) */}
          <div className="flex-fill me-3">
            <div className="p-3 shadow rounded bg-white h-100 d-flex flex-column">
              <h3 className="text-center mb-3">Movie Articles</h3>
              <div className="flex-grow-1 overflow-auto">
                {articles.map(a => (
                  <Link key={a._id} to={`/article/${a._id}`} className="text-decoration-none">
                    <div className="card mb-3 p-2 article-card">
                      <h6>{a.title}</h6>
                      <p className="mb-0 text-muted">{a.content.slice(0,120)}...</p>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </div>

          {/* Right side: two stacked columns */}
          <div style={{ width: 360, minWidth: 280 }}>
            <div className="d-flex flex-column h-100" style={{ gap: 16 }}>
              <div className="p-3 shadow rounded bg-white mb-3">
                <h5 className="text-center mb-3">Reviews</h5>
                {reviews.map(r => (
                  <Link key={r._id} to={`/article/${r._id}`} className="text-decoration-none">
                    <div className="card mb-2 p-2 article-card">
                      <h6>{r.title}</h6>
                      {/* <p className="mb-0 text-muted">{r.content.slice(0,100)}...</p> */}
                        <p className="mb-0 text-muted">
                          {stripHtml(r.content).slice(0, 120)}...
                        </p>
                    </div>
                  </Link>
                ))}
                {reviews.length === 0 && <p className="text-muted">No reviews found</p>}
              </div>

              <div className="p-3 shadow rounded bg-white">
                <h5 className="text-center mb-3">Box Office Reports</h5>
                {boxoffice.map(b => (
                  <Link key={b._id} to={`/article/${b._id}`} className="text-decoration-none">
                    <div className="card mb-2 p-2 article-card">
                      <h6>{b.title}</h6>
                      <p className="mb-0 text-muted">{b.content.slice(0,100)}...</p>
                    </div>
                  </Link>
                ))}
                {boxoffice.length === 0 && <p className="text-muted">No box office reports found.</p>}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default MoviesPage;
